import { Box, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import SectionHeader from '../SectionHeader'
import { BENCHMARK_ROWS } from './resultsMockData'

/** This study vs. category-norm overlaid bars per emotion. */
export default function BenchmarkCard() {
  const theme = useTheme()
  const c = theme.affexy.colors
  const { t } = useTranslation('results')

  return (
    <Box sx={{ bgcolor: c.white, border: `1px solid ${c.ink08}`, borderRadius: '16px', p: 2.5, display: 'flex', flexDirection: 'column', gap: 1.75 }}>
      <SectionHeader title={t('benchmark.title')} subtitle={t('benchmark.sub')} />
      <Stack spacing={1.25}>
        {BENCHMARK_ROWS.map((r) => {
          const pos = r.d.startsWith('+')
          return (
            <Stack key={r.labelKey} spacing={0.5}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography sx={{ fontSize: 13, color: c.ink, fontWeight: 500 }}>{t(`benchmark.${r.labelKey}`)}</Typography>
                <Typography sx={{ fontSize: 12, fontWeight: 700, color: pos ? c.success : c.danger, fontVariantNumeric: 'tabular-nums' }}>
                  {r.d}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                <Box sx={{ flex: 1, height: 8, bgcolor: c.gray100, borderRadius: `${theme.affexy.radii.pill}px`, position: 'relative', overflow: 'hidden' }}>
                  <Box sx={{ position: 'absolute', left: 0, top: 0, height: '100%', width: `${r.b}%`, bgcolor: c.gray300 }} />
                  <Box sx={{ position: 'absolute', left: 0, top: 0, height: '100%', width: `${r.a}%`, bgcolor: c.coral }} />
                </Box>
                <Typography sx={{ fontSize: 11, color: c.ink56, fontVariantNumeric: 'tabular-nums', width: 50, textAlign: 'right' }}>
                  {r.a}% / {r.b}%
                </Typography>
              </Box>
            </Stack>
          )
        })}
      </Stack>
      <Box sx={{ display: 'flex', gap: 1.75, fontSize: 11, color: c.ink56 }}>
        <Box component="span" sx={{ display: 'inline-flex', gap: 0.75, alignItems: 'center' }}>
          <Box component="span" sx={{ width: 10, height: 10, borderRadius: '3px', bgcolor: c.coral }} />
          {t('benchmark.thisStudy')}
        </Box>
        <Box component="span" sx={{ display: 'inline-flex', gap: 0.75, alignItems: 'center' }}>
          <Box component="span" sx={{ width: 10, height: 10, borderRadius: '3px', bgcolor: c.gray300 }} />
          {t('benchmark.norm')}
        </Box>
      </Box>
    </Box>
  )
}
